var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9633 13.1615C11.1881 12.9367 11.5752 12.9367 11.8 13.1615L15.0054 16.3669C15.5965 16.958 16.3833 17.2827 17.2158 17.2827H17.8444L13.8023 21.3248C12.541 22.5528 10.4929 22.5528 9.23157 21.3248L5.17283 17.2702H5.55997C6.39254 17.2702 7.1793 16.9455 7.77042 16.3544L10.9633 13.1615ZM11.8 10.0977C11.5336 10.3267 11.1922 10.3308 10.9633 10.0977L7.77042 6.90483C7.1793 6.27625 6.39254 5.98902 5.55997 5.98902H5.17283L9.2274 1.93278C10.4929 0.669541 12.541 0.669541 13.8023 1.93278L17.8486 5.97653H17.2158C16.3833 5.97653 15.5965 6.30123 15.0054 6.89235L11.8 10.0977ZM5.55997 6.92565C6.13444 6.92565 6.66312 7.15877 7.10437 7.56672L10.2972 10.7596C10.597 11.0218 10.9883 11.2092 11.3837 11.2092C11.775 11.2092 12.1663 11.0218 12.4661 10.7596L15.6714 7.55423C16.0794 7.15044 16.6414 6.91732 17.2158 6.91732H18.7852L21.2121 9.34424C22.4734 10.6056 22.4734 12.6537 21.2121 13.915L18.7852 16.3419H17.2158C16.6414 16.3419 16.0794 16.1088 15.6714 15.7008L12.4661 12.4955C11.8874 11.9168 10.8759 11.9168 10.2972 12.4996L7.10437 15.6883C6.66312 16.0963 6.13444 16.3294 5.55997 16.3294H4.23537L1.82011 13.915C0.55687 12.6537 0.55687 10.6056 1.82011 9.34424L4.23537 6.92565H5.55997Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3135,
    height: 21.3135,
    fill: "white",
    transform: "translate(0.87207 0.984863)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.8d13d87059adfd7f8242dd17ce94c3a9.svg";
export { ForwardRef as ReactComponent };